import { render, staticRenderFns } from "./projectchange-add-or-update.vue?vue&type=template&id=37b6efa9&scoped=true"
import script from "./projectchange-add-or-update.vue?vue&type=script&lang=js"
export * from "./projectchange-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./projectchange-add-or-update.vue?vue&type=style&index=0&id=37b6efa9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6efa9",
  null
  
)

export default component.exports